module.exports = __webpack_public_path__ + "img/Visa.b46ced7e.svg";